/** HELPERS */
import {is_iOS} from "./Helpers/Body";

/** SECTIONS */
import Testimonials from "./Sections/Testimonials";

/** STYLES */
import '../scss/Index.scss';

class IndexController {
    constructor() {
        if (is_iOS()) {
            document.body.classList.add('ios');
        }
    }
}

document.addEventListener("DOMContentLoaded", function (event) {
    new IndexController();
})
